import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invitedUser: {
		id: 'users-and-roles.actors-table.mention-item.invited-user',
		defaultMessage: 'Invited',
		description: 'Marks a user in the table as invited.',
	},
});
